import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import DatePicker from 'react-datepicker';
import * as moment from 'moment';
import CustomSelect from '../../common/formElements/CustomSelect';
import CustomLoader from './CustomLoader';
import { drapcodeIcon, iconForField } from '../../common/custom/icon-library';
import { validateConstantType, validateName, validateValue } from '../../common/utils/validate';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';
import { prepareValidationForCustomConstant } from '../data-connector/common/common_utils';

const customConstantSchema = {
  constantType: '',
  name: '',
  value: '',
};
export default class ConstantForm extends Component {
  constructor(props) {
    super(props);
  }
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    constantType: PropTypes.string,
    constant: PropTypes.object,
    isCollection: PropTypes.bool,
  };

  state = {
    constantType: this.props.constantType,

    value: '',
    constantTypes: [
      { value: '', label: '-Select One-' },
      { value: 'BOOLEAN', label: 'Boolean' },
      { value: 'DATE', label: 'Date' },
      { value: 'EMAIL', label: 'Email' },
      { value: 'LIST', label: 'List' },
      { value: 'NUMBER', label: 'Number' },
      { value: 'STRING', label: 'String' },
    ],
  };

  clearForm = () => {
    customConstantSchema.constantType = '';
    customConstantSchema.name = '';
    customConstantSchema.value = '';
    this.setState({ constantType: '' });
  };

  handleSubmit = (values) => {
    const { constantType } = values;
    if (constantType === 'BOOLEAN') {
      values.value = values.value ? values.value : false;
    }
    this.props.handleSubmit(values);
    if (!this.props.isCollection) {
      this.setState({ value: '' });
    }
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  createField = (setFieldValue, setFieldTouched) => {
    const { constantType } = this.state;
    if (constantType === 'STRING') {
      return (
        <CustomInputWithIcon required={true} icon="text">
          <Field
            type="text"
            name="value"
            validate={validateValue}
            className="form-control form-control-sm"
            placeholder="Value"
          />
        </CustomInputWithIcon>
      );
    }
    if (constantType === 'EMAIL') {
      return (
        <CustomInputWithIcon icon="email" required={true}>
          <Field
            type="email"
            name="value"
            validate={validateValue}
            className="form-control form-control-sm"
            placeholder="Value"
          />
        </CustomInputWithIcon>
      );
    }
    if (constantType === 'NUMBER') {
      return (
        <CustomInputWithIcon icon="text" required="true">
          <Field
            type="number"
            validate={validateValue}
            name="value"
            className="form-control form-control-sm"
            placeholder="Value"
          />
        </CustomInputWithIcon>
      );
    }
    if (constantType === 'BOOLEAN') {
      return (
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">
              <i className={`wb ${iconForField('boolean-toggle')}`}></i>
              <span className="required"> *</span>
            </span>
          </div>
          <div className="form-check">
            <label className="form-check-label">
              <Field type="checkbox" name="value" className="form-check-input" />
              <span className="form-check-sign">
                <span className="check"></span>
              </span>
            </label>
          </div>
        </div>
      );
    }
    if (constantType === 'LIST') {
      return (
        <CustomInputWithIcon icon="text" required={true}>
          <Field
            type="text"
            name="value"
            validate={validateValue}
            className="form-control form-control-sm"
            placeholder="Value"
          />
          <small className="field-detail">Separate value by comma</small>
        </CustomInputWithIcon>
      );
    }
    if (constantType === 'DATE') {
      return (
        <CustomInputWithIcon icon="date" required={true}>
          <Field
            as={DatePicker}
            name="value"
            selected={this.state.value ? moment(this.state.value).toDate() : ''}
            showTimeSelect
            timeFormat="h:mm a"
            timeIntervals={15}
            timeCaption="time"
            dateFormat="MMMM d, yyyy h:mm aa"
            className="form-control form-control-sm"
            onChange={(date) => {
              this.setState({ value: date });
              setFieldValue('value', date);
            }}
            validate={validateValue}
            placeholder="Value"
          />
        </CustomInputWithIcon>
      );
    }
  };

  createCustomFieldForValue = (setFieldValue, setFieldTouched) => {
    const { constantType } = this.state;
    if (!constantType) {
      return '';
    }

    return (
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
        {this.createField(setFieldValue, setFieldTouched)}
        <ErrorMessage name="value">{(msg) => <p className="text-error">{msg}</p>}</ErrorMessage>
      </div>
    );
  };

  render() {
    const { constant, isCollection, showDerivedConstantLoader, isReadOnly } = this.props;
    customConstantSchema.name = constant ? constant.name : '';
    customConstantSchema.value = constant ? constant.value : '';
    customConstantSchema.constantType = constant ? constant.constantType : '';
    return (
      <>
        <Formik
          initialValues={customConstantSchema}
          validationSchema={prepareValidationForCustomConstant()}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            !isReadOnly && this.handleSubmit(values);
            if (!isCollection) {
              setSubmitting(false);
              this.clearForm();
              resetForm();
            }
          }}
        >
          {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
            return (
              <Form className="form-horizontal">
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <CustomInputWithIcon icon="text" required={true}>
                      <Field
                        type="text"
                        name="name"
                        className="form-control form-control-sm"
                        placeholder="Name of Constant"
                        validate={validateName}
                      />
                      <ErrorMessage name="name">
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </CustomInputWithIcon>
                  </div>
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <CustomInputWithIcon icon="select" required={true} title="Constant Type">
                      <Field
                        as={CustomSelect}
                        name="constantType"
                        isMulti={false}
                        options={this.state.constantTypes}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        onChangeValue={this.handleChange}
                        validate={validateConstantType}
                        placeholder="Constant Type"
                      />
                      <small className="field-details">Type of constant</small>
                      <ErrorMessage name="constantType">
                        {(msg) => <p className="pl-0 ml-5 mt-5 text-error">{msg}</p>}
                      </ErrorMessage>
                      <div className="input-group-append">
                        <span
                          className="input-group-text"
                          data-tip="Type of constant"
                          title="Allows you to choose how data in a collection will get sorted after binding the filter to a CMS component. You can choose any of the following settings: Created At, to sort the data according to the date of creation. Updated At, to sort the data according to the date on which it was updated. ID, to sort the data according to their unique IDs.
"
                        >
                          <i className={`wb ${drapcodeIcon('description')}`}></i>
                        </span>
                      </div>
                    </CustomInputWithIcon>
                  </div>
                  {this.createCustomFieldForValue(setFieldValue, setFieldTouched)}
                  <div className="col-md-12 col-lg-12 mt-2 text-right d-flex justify-content-between">
                    <div>
                      {' '}
                      {this.props.cancelToggle && (
                        <button
                          type="reset"
                          className="btn btn-outline btn-md "
                          onClick={() => this.props.toggle('appConstant')}
                        >
                          <i className="wb webconnect-times"> </i> Cancel
                        </button>
                      )}
                    </div>
                    <div className="d-flex flex-end">
                      {!constant ? (
                        <button
                          type="button"
                          className="btn btn-default btn-md"
                          onClick={() => {
                            resetForm();
                            this.clearForm();
                          }}
                        >
                          <span>
                            <i className={`wb ${drapcodeIcon('clear')}`}></i>&nbsp;Clear
                          </span>
                        </button>
                      ) : (
                        ''
                      )}
                      <button
                        type="submit"
                        className="btn btn-theme-submit btn-md"
                        disabled={
                          (isSubmitting && showDerivedConstantLoader) || isReadOnly
                            ? 'disabled'
                            : ''
                        }
                        title={isReadOnly && 'Read-Only Mode'}
                      >
                        <i className="wb webconnect-plus"></i>&nbsp;
                        {!constant ? 'Create' : 'Update'}&nbsp;
                        <CustomLoader loading={showDerivedConstantLoader} />
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </>
    );
  }
}
